const CHUNK_SIZE = 4 * 1024 * 1024; // 4MB
const blobToArrayBuffer = async (blob) =>{
    return await blob.arrayBuffer();
}

export async function commitBlocks(uploadUrl, blockIds) {
    const xml =
        `<?xml version="1.0" encoding="utf-8"?><BlockList>` +
        blockIds.map(id => `<Latest>${id}</Latest>`).join("") +
        `</BlockList>`;

    await fetch(`${uploadUrl}&comp=blocklist`, {
        method: "PUT",
        body: xml
    });
}
export async function uploadBlobChunks(uploadUrl, blob, onProgress) {

  const blockIds = [];
  let offset = 0;
  let index = 0;

  while (offset < blob.size) {

    const chunk = blob.slice(offset, offset + CHUNK_SIZE);

    const blockId = btoa(index.toString().padStart(6, "0"));
    blockIds.push(blockId);

    const url =
      `${uploadUrl}&comp=block&blockid=${encodeURIComponent(blockId)}`;

    await putBlockWithRetry(url, chunk);


    if (onProgress) onProgress(chunk.size); 
    
    offset += CHUNK_SIZE;
    index++;
  }

  return blockIds;
}
export async function uploadBlobChunksSinglePost(uploadUrl, blob) {

    // debugger;
    const blockIds = [];
    let offset = 0;
    let index = 0;

    while (offset < blob.size) {

        const chunk = blob.slice(offset, offset + CHUNK_SIZE);

        const blockId = btoa(index.toString().padStart(6, "0"));
        blockIds.push(blockId);

        await fetch(
            `${uploadUrl}&comp=block&blockid=${encodeURIComponent(blockId)}`,
            {
                method: "PUT",
                headers: { "x-ms-blob-type": "BlockBlob" },
                body: chunk
            }
        );

        offset += CHUNK_SIZE;
        index++;
    }

    return blockIds;
}
async function putBlockWithRetry(url, chunk, retries = 3) {

  for (let attempt = 1; attempt <= retries; attempt++) {

    try {

      const response = await fetch(url, {
        method: "PUT",
        headers: { "x-ms-blob-type": "BlockBlob" },
        body: chunk
      });

      if (response.ok) return;

      if (![403, 408, 429, 500, 502, 503, 504].includes(response.status))
        throw new Error(`Upload failed: ${response.status}`);

      console.warn(`Retry ${attempt} for block...`);

    } catch (err) {

      if (attempt === retries) throw err;
    }

    await new Promise(r => setTimeout(r, attempt * 1000));
  }
}
